import { googleMapsApiKeys, toolTestUrls } from '@warema/shared/constants';
import { WaremaPlusEnvironment } from '@warema/shared/models';
import { baseOAuthConfig } from './base-environment';

const appUrl = 'https://plus-test.warema.com';
const baseLeadCloudUrl = 'https://leadcloud-test.warema.com';
const baseLeadCloudApiUrl = baseLeadCloudUrl + '/api';
const leadCloudApiV1 = 'v1.0';
const leadCloudApiV2 = 'v2.0';
const authUrl = 'https://auth-test.warema.de/v1';
const deviceCloudBaseUrl = 'https://devicecloudservice.test.devicecloud.warema.de/api/v1.0';

export const environment: WaremaPlusEnvironment = {
    production: true,
    instance: 'test',
    currentReleasedCommitSHA: 'cf49c59acbd50a9b565fc8afba8b6a8bca5470a7',
    buildVersion: 'cf49c59acbd50a9b565fc8afba8b6a8bca5470a7'.substring(0, 7),
    googleMapsApiKey: googleMapsApiKeys.test,
    baseLeadCloudUrl,
    baseLeadCloudApiUrl: `${baseLeadCloudApiUrl}/${leadCloudApiV1}`,
    agreementsBaseUrl: `${baseLeadCloudApiUrl}/${leadCloudApiV1}/Agreements`,
    agreementsV2BaseUrl: `${baseLeadCloudApiUrl}/${leadCloudApiV2}/Agreements`,
    oauth: {
        ...baseOAuthConfig,
        issuer: authUrl,
        redirectUri: appUrl,
        silentRefreshRedirectUri: `${appUrl}/assets/auth/silent-refresh.html`,
    },
    userUrl: `${baseLeadCloudApiUrl}/${leadCloudApiV1}/Users`,
    authenticatedUrls: [authUrl, baseLeadCloudUrl, deviceCloudBaseUrl],
    deviceCloudBaseUrl,
    businessCardsUrl: `https://businesscards-test.warema.com`,
    configuratorUrl: 'https://configurator-test.warema.com',
    shopInfoPdfUrl:
        'https://leadcloudtestwesa.blob.core.windows.net/shop/general_documents/RL_Konfektionierten_Markisentuechern.pdf',
    azureBlobUrl: 'https://leadcloudtestwesa.blob.core.windows.net',
    createAccountGuideUrl:
        'https://leadcloudtestwesa.blob.core.windows.net/public/warema_alhb_anleitung-waremaplus_210716_low_de.pdf',
    apm: {
        serviceName: 'EBiz_WaremaPlus',
        serviceVersion: 'cf49c59acbd50a9b565fc8afba8b6a8bca5470a7',
        active: true,
        environment: 'TEST',
        apiVersion: 3,
        flushInterval: 3000,
        serverUrl: 'https://d67a8629a0c14a97b441f5f8f0e7e276.apm.westeurope.azure.elastic-cloud.com:443',
        breakdownMetrics: true,
        distributedTracingOrigins: [
            'https://ebizapistest.warema.de',
            'https://auth-test.warema.de',
            'https://leadcloud-test.warema.com',
        ],
        transactionSampleRate: 1.0,
    },
    toolUrls: toolTestUrls,
    businessDataUrl: 'https://waremadesignertestwesa.blob.core.windows.net/warema-designer-web-business-data',
};
